import type { ComponentChildren } from "preact";
import { TextInput } from "./Fields.tsx";
import { cx } from "./lib/cx.ts";

export interface ListToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  /** Extra controls (a sort select, a PillGroup) between the search and the count. */
  children?: ComponentChildren;
  /** Right-aligned muted text; truncates with the full text on hover. */
  count?: string;
  class?: string;
}

/**
 * The single row above a list: search, optional controls, a count. Rule: it
 * stays one row. The search flexes between 8rem and 16rem and the count
 * truncates (its full text is the `title`) rather than wrapping the row.
 */
export function ListToolbar({ searchValue, onSearchChange, searchPlaceholder = "Search", children, count, class: className }: ListToolbarProps) {
  return (
    <div class={cx("ui-toolbar", className)}>
      <div class="ui-toolbar__search">
        <TextInput
          type="search"
          value={searchValue}
          placeholder={searchPlaceholder}
          aria-label="Search"
          onInput={(e) => onSearchChange(e.currentTarget.value)}
        />
      </div>
      {children !== undefined && <div class="ui-toolbar__controls">{children}</div>}
      {count !== undefined && (
        <span class="ui-toolbar__count" title={count}>
          {count}
        </span>
      )}
    </div>
  );
}
